export var SendStatus;
(function (SendStatus) {
    SendStatus[SendStatus["sending"] = 0] = "sending";
    SendStatus[SendStatus["sent"] = 1] = "sent";
    SendStatus[SendStatus["delivered"] = 2] = "delivered";
    SendStatus[SendStatus["read"] = 3] = "read";
    SendStatus[SendStatus["failed"] = -1] = "failed";
    SendStatus[SendStatus["rejected"] = -2] = "rejected";
    SendStatus[SendStatus["notification_sent"] = 4] = "notification_sent";
    SendStatus[SendStatus["notification_delivered"] = 5] = "notification_delivered";
    SendStatus[SendStatus["notification_read"] = 6] = "notification_read";
    SendStatus[SendStatus["notification_failed"] = -5] = "notification_failed";
    SendStatus[SendStatus["notification_rejected"] = -6] = "notification_rejected";
})(SendStatus || (SendStatus = {}));
